<div class="layout-wrapper" [ngClass]="containerClass" style="background-color: rgb(222, 222, 232);">
    <app-topbar></app-topbar>
    <div class="layout-sidebar" style="background-color: #1d2f6d; ">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main" >
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-config></app-config>
    <div class="layout-mask"></div>
</div>
